import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../../../base/base-component.component';
import { SiteSettingModel, MenuModel, PageModel, MenuItemDto } from '../../../../services';

@Component({
  selector: 'menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.css']
})
export class MenuItemComponent extends BaseComponent implements OnInit {

  @Input()
  siteSettingModel: SiteSettingModel;

  @Input()
  menu: MenuModel;

  @Input()
  menuItemDtos: Array<MenuItemDto>;

  @Input()
  menuItemDto: MenuItemDto;

  @Input()
  parentMenuItemDto: MenuItemDto = null;

  @Input()
  rootMenuItemDtos: Array<MenuItemDto> = null;

  @Input()
  pages: Array<PageModel> = null;

  @Output()
  onDrag: EventEmitter<any> = new EventEmitter();

  @ViewChild("plusIcon") plusRef: ElementRef;
  @ViewChild("minusIcon") minusRef: ElementRef;

  hasChildren: boolean;
  childrenDto: Array<MenuItemDto>;

  constructor(translateService: TranslateService,
    private plusIcon: ElementRef,
    private minusIcon: ElementRef
    ) {
      super(translateService);
      this.setTranslateContext('MenuItemComponent');
    }

    ngOnInit() {

      this.childrenDto = this.menuItemDtos.filter(v =>
        v.menuItem.data.parentMenuItem.iv[0] === this.menuItemDto.menuItem.id
        && this.menuItemDto.menuItem.data.deleted.iv != true
        && this.menuItemDto.menuItem.status == 'Published');

      this.hasChildren = this.childrenDto.length > 0;
    }

      private getLabel(menuItemDto: MenuItemDto): string {
        const page = this.dParser.pullData(this.menuItemDto.menuItem, 'page');
        const pageObj = this.pages.find(p => p.id === page);

        let label = this.dParser.pullData(pageObj, 'pageName');

        if (!label) {
          label = this.dParser.pullData(menuItemDto.menuItem, 'label', this.getCurrentCulture());
        }

        if (!label) {
          label = this.dParser.pullData(menuItemDto.menuItem, 'code');
        }

        return label;
      }

      private getMenuItemPath(): string {

        if (!this.menuItemDto.menuItem.data.page) {
          return '';
        }

        const page = this.dParser.pullData(this.menuItemDto.menuItem, 'page');
        const link = this.dParser.pullData(this.menuItemDto.menuItem, 'link');
        const menuCode = this.dParser.pullData(this.menuItemDto.menuItem, 'code');
        let path = '/page/';
        if (link) {
          path = link;
        } else if (page && this.pages) {
          const pageObj = this.pages.find(p => p.id === page);
          if (pageObj) {
            const schemaName = this.dParser.pullData(this.menuItemDto.menuItem, 'schemaname');
            const parent = schemaName !== '' ? schemaName + '/' : '';
            //const pageLink = this.dParser.pullData(pageObj, 'url', this.getCurrentCulture());
            const pageCode = this.dParser.pullData(pageObj, 'code');
            // TO DO
            // Does not work in frenh
            // if (pageLink)
            //  path += parent + pageLink
            if (pageCode) {
              path += parent + pageCode;
            }
          } else {
            const parentMenu = this.menuItemDtos.find(p => p.menuItem.id === this.menuItemDto.menuItem.data.parentMenuItem.iv[0]);
            if (parentMenu) {
              const parentPath = this.dParser.pullData(parentMenu.menuItem, 'code');
              path += parentPath + '/' + menuCode;
            }
          }
        }
        if ((path === '' || path === '/page/') && menuCode) {
          path += menuCode;
        }

        return path;
      }

      collapseMenuItem() {
        if (this.menuItemDto.isCurrentPage || this.menuItemDto.isVisible ) {
          return 'collapse show';
        }
        return 'collapse';
      }

        isSelected() {
        let classes = 'on-hover no-drag pl-1';
        if (this.menuItemDto.isCurrentPage) {
          classes += ' is-selected';
        }
        return classes;
      }

      //  used ngclass
      isSelectedIcon() {
        let classes = '';
        if (this.menuItemDto.isCurrentPage) {
          classes = 'text-white';
        }
        return classes;
      }

      //  Moved to custom pipe
      isSelectedChildren() {
        let classes = 'on-hover no-drag pl-1 ';
        if (this.menuItemDto.isCurrentPage) {
          const selectedChild = this.menuItemDtos.find(m => m.isCurrentPage && this.menuItemDto.menuItem.id === m.menuItem.data.parentMenuItem.iv[0]);
          if (!selectedChild) {
            classes += ' is-selected';
          }
        }
        return classes;
      }

      //  Moved to custom pipe
      isSelectedIconPlus(menu: MenuItemDto) {
        let classes = 'fa fa-plus pb-2 pt-2';

        if (this.menuItemDto.isCurrentPage) {
          const selectedChild = this.menuItemDtos.find(m => m.isCurrentPage && this.menuItemDto.menuItem.id === m.menuItem.data.parentMenuItem.iv[0]);
          if (!selectedChild) {
            classes += 'text-white';
          }
        }

        let showIcon = ' d-inline';
        if (menu.menuItem.id === this.menuItemDto.menuItem.id) {
          if (menu.isVisible || menu.isCurrentPage) {
            showIcon = ' d-none';
          }
        }
        return classes + showIcon;
      }

      //  Moved to custom pipe
      isSelectedIconMinus(menu) {
        let classes = 'fa fa-minus pb-2 pt-2';

        if (this.menuItemDto.isCurrentPage) {
          const selectedChild = this.menuItemDtos.find(m => m.isCurrentPage && this.menuItemDto.menuItem.id === m.menuItem.data.parentMenuItem.iv[0]);
          if (!selectedChild) {
            classes += ' text-white';
          }
        }

        let showIcon = ' d-inline';
        if (menu.menuItem.id === this.menuItemDto.menuItem.id) {
          if ((!menu.isVisible && !menu.isCurrentPage)) {
            showIcon = ' d-none';
          }
        }

        return classes + showIcon;
      }

      changeSign(elem: HTMLElement) {
        elem.classList.remove("d-inline");
        elem.classList.add("d-none");
        if (elem.classList.contains('fa-minus')) {
          this.plusRef.nativeElement.classList.add('d-inline');
          this.plusRef.nativeElement.classList.remove('d-none');
          if (this.minusRef.nativeElement.classList.contains('text-white')) {
            this.plusRef.nativeElement.classList.add('text-white');
            this.menuItemDto.isVisible = true;
          }

        } else {
          this.minusRef.nativeElement.classList.add('d-inline');
          this.minusRef.nativeElement.classList.remove('d-none');
          if (this.plusRef.nativeElement.classList.contains('text-white')) {
            this.minusRef.nativeElement.classList.add('text-white');
            this.menuItemDto.isVisible = false;
          }
        }
      }

      //  Moved to custom pipe
      isLinkDisabled() {

        if (!this.menuItemDto.menuItem.data.page) {
          return 'disabled';
        } else if (!this.menuItemDto.menuItem.data.page.iv) {
          return 'disabled';
        }
        return '';
      }

      openDeleteModal(): void {
        this.onDeleteEvent.emit(this.article);
      }

      drag(event): void {
        this.onDrag.emit(event);
      }
    }
